import React from 'react'

export default ({ onClick }) => (
  <div
    className="cross"
    onClick={e => (onClick ? onClick(e) : e.preventDefault())}
  >
    <span />
    <span />
  </div>
)
